





























import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
const cssPrefix: string = 'deleteUserInner';
@Component({

})
export default class DeleteUserInner extends SwExtendedVue {
  cssPrefix: string = cssPrefix;
}
